import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, FormControl, InputLabel, MenuItem, Select, Chip, FormHelperText, Input, InputAdornment } from '@material-ui/core';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            minWidth: 250
        }
    }
};

class FHESelectField extends PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        classes: PropTypes.object.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.number]).isRequired,
        error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        multiple: PropTypes.bool,
        displayEmpty: PropTypes.bool,
        component: PropTypes.bool,
        name: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        emptyFunc: PropTypes.func,
        itemTitle: PropTypes.string,
        className: PropTypes.string,
        suffix: PropTypes.string,
        choices: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        disabledValues: PropTypes.array
    };

    static defaultProps = {
        emptyFunc: null,
        displayEmpty: false,
        disabled: false,
        multiple: false,
        component: false,
        name: '',
        error: null,
        itemTitle: null,
        className: null,
        disabledValues: [],
        choices: null,
        suffix: null
    };

    choiceRender = () => {
        const { choices, disabledValues, component } = this.props;
        let data = [];
        const isArray = Array.isArray(choices);
        if (isArray)
            choices.forEach(item => {
                return data.push(this.formatData(item.id, item.id, component ? item.component : item.label, item.disabled));
            });
        else
            Object.keys(choices).forEach(key => {
                return data.push(this.formatData(key, key, choices[key], disabledValues.includes(key)));
            });

        return data;
    };

    formatData = (key, value, children, disabled = false) => {
        const { classes } = this.props;
        return (
            <MenuItem key={key} value={value} classes={{ root: classes.menuItem, selected: classes.menuItemSelected }} disabled={disabled}>
                {children}
            </MenuItem>
        );
    };

    render() {
        const {
            component,
            suffix,
            value,
            name,
            itemTitle,
            className,
            classes,
            disabled,
            onChange,
            multiple,
            choices,
            error,
            displayEmpty,
            emptyFunc
        } = this.props;

        const underlineStyle = error === null ? null : classes.underline;
        return (
            <FormControl className={`${classes.FHESelectFieldContainer} ${className}`} disabled={disabled}>
                <InputLabel error={!!error} shrink htmlFor="age-label-placeholder" className={classes.label}>
                    {itemTitle}
                </InputLabel>
                <Select
                    displayEmpty={displayEmpty}
                    value={value}
                    input={
                        <Input
                            endAdornment={suffix ? <InputAdornment className={classes.InputAdornment}>{suffix}</InputAdornment> : null}
                            classes={{
                                underline: underlineStyle
                            }}
                        />
                    }
                    onChange={onChange}
                    name={name}
                    multiple={multiple}
                    className={classes.selectFheSelectField}
                    MenuProps={MenuProps}
                    renderValue={
                        Array.isArray(choices) && multiple
                            ? selected => {
                                  if (component)
                                      return (
                                          <div className={classes.multipleButtonsSelected}>
                                              {selected.map(id => choices.find(item => item.id === id).component)}
                                          </div>
                                      );
                                  else {
                                      return (
                                          <div className={classes.multipleSelected}>
                                              {selected.map((item, key) => (
                                                  <Chip key={key} label={choices.find(obj => obj.id === item).label} className={classes.chip} />
                                              ))}
                                          </div>
                                      );
                                  }
                              }
                            : multiple
                            ? selected => (
                                  <div className={classes.multipleSelected}>
                                      {selected.map((item, key) => (
                                          <Chip key={key} label={item} className={classes.chip} />
                                      ))}
                                  </div>
                              )
                            : displayEmpty
                            ? emptyFunc
                            : null
                    }
                >
                    {this.choiceRender()}
                </Select>
                <FormHelperText className={classes.FormHelperText} component="div">
                    {error}
                </FormHelperText>
            </FormControl>
        );
    }
}
const styles = theme => ({
    underline: {
        '&:before': {
            borderBottom: `2px solid ${theme.palette.error.main}`
        }
    },
    FHESelectFieldContainer: {
        top: 11,
        width: '100%',
        minHeight: 72
    },
    InputAdornment: {
        top: 'calc(50%)',
        right: 20,
        position: 'absolute'
    },
    label: {
        fontSize: '1.2em'
    },
    menuItem: {
        margin: '5px',
        borderRadius: theme.shape.borderRadius
    },
    menuItemSelected: {
        color: theme.palette.common.white,
        fontWeight: '500',
        backgroundColor: `${theme.palette.primary.main} !important`
    },
    multipleSelected: {
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    },
    selectFheSelectField: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    FormHelperText: {
        color: theme.palette.error.main
    },
    chip: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        margin: 5,
        display: 'flex',
        flexWrap: 'wrap'
    },
    multipleButtonsSelected: {
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    }
});

export default withStyles(styles, { withTheme: true })(FHESelectField);



// WEBPACK FOOTER //
// ./data/components/FHESelectField.js